// extracted by mini-css-extract-plugin
module.exports = {"container":"CharityPicture-module--container--u7PKp"};